<!-- ================阅读拓展馆-美育浸润====================-->
<template>
    <div class="aec-edu-container">
        <home-head />
        <div class="aec-edu-body">
            <div class="aec-edu-inner">
                <!-- 标题区 -->
                <div class="aec-edu-header">
                    <div class="aec-edu-title-box">
                        <div class="aec-edu-title">美育浸润</div>
                        <div class="aec-edu-subtitle">十四个系列视频资源</div>
                    </div>
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                </div>
                <!-- 视频资源卡片 -->
                <div class="aec-edu-cards">
                    <div class="aec-edu-card cursor" v-for="(item, index) in filteredList" :key="index" @click="handleCardClick(item)">
                        <div class="aec-edu-card-inner">
                            <div class="aec-edu-card-title">{{ item.itemName }}</div>
                            <div class="aec-edu-card-desc">{{ item.itemClassify || '' }}</div>
                        </div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="filteredList.length === 0 && !loading">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无资源</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { humItemList } from "@/api/admin/humanityItem";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "readAestheticEdu",
    data() {
        return {
            loading: false,
            searchKeyword: "",
            themeKey: "",
            museumKey: "1",
            filteredList: [
            ],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryHumItemList();
    },
    mounted() {},
    methods: {
        /* ===============数据查询===================== */
        queryHumItemList(){
            humItemList({museumKey:this.museumKey}).then(res => {
                if (res.data.code===1){
                    this.filteredList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },

        /* ===============跳转===================== */
        goBack() {
            this.$router.push("/museum/read");
        },
        handleCardClick(item) {
            this.$router.push({
                path: "/bymy/theme",
                query: { itemId: item.itemId, businessType: 1, collectType: 2 },
            });
        }
    }
}
</script>

<style scoped>
.aec-edu-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.aec-edu-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.aec-edu-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.aec-edu-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.aec-edu-title-box {
    display: flex;
    flex-direction: column;
}

.aec-edu-title {
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}

.aec-edu-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

/* 卡片列表 */
.aec-edu-cards {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    align-content: flex-start;
    padding-top: 10px;
    box-sizing: border-box;
}

.aec-edu-cards::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.aec-edu-cards::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}
.aec-edu-cards::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}
.aec-edu-cards::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.aec-edu-card {
    min-width: 0;
    min-height: 200px;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.aec-edu-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.aec-edu-card-inner {
    width: 100%;
    height: 100%;
    border: 1px solid #e99d42;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
}

.aec-edu-card-title {
    font-size: 20px;
    color: #6b7280;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 20px;
}

.aec-edu-card-desc {
    font-size: 15px;
    color: #6b7280;
    font-family: sans-serif;
    line-height: 1.6;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.empty-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
}

.empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

@media (max-width: 1024px) {
    .aec-edu-cards { grid-template-columns: repeat(3, 1fr); gap: 16px; }
    .aec-edu-card-title { font-size: 20px; }
    .aec-edu-card-desc { font-size: 14px; }
}

@media (max-width: 768px) {
    .aec-edu-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .aec-edu-filter { flex-direction: column; align-items: flex-start; gap: 12px; }
    .filter-select { width: 180px; }
    .filter-right { width: 100%; }
    .search-input { flex: 1; }
    .aec-edu-cards { grid-template-columns: repeat(2, 1fr); gap: 12px; }
    .aec-edu-card { min-height: 160px; }
    .aec-edu-card-title { font-size: 18px; margin-bottom: 12px; }
    .aec-edu-card-desc { font-size: 13px; }
}
</style>
